export default __webpack_public_path__ + "static/media/powerBI-logo.343bd0cd.svg";